import { useState } from "react";

interface Community {
  name: string;
  route: string;
}

interface Subregion {
  name: string;
  description: string;
  communities: Community[];
  hub: { name: string; route: string };
}

interface Region {
  id: string;
  name: string;
  icon: string;
  subregions: Subregion[];
}

const regions: Region[] = [
  {
    id: "central-indiana",
    name: "Central Indiana",
    icon: "ri-building-2-line",
    subregions: [
      {
        name: "Indianapolis Metro",
        description: "Indianapolis, Carmel, Fishers, and Noblesville form the Central Indiana core. The Indianapolis Passport Agency (4419 Indiana Ave) is the only regional passport agency in Indiana — making Indianapolis the fastest city in the state for emergency passport service. I-65, I-70, and I-465 connect the metro area.",
        hub: { name: "Indianapolis", route: "/cities/indianapolis" },
        communities: [
          { name: "Carmel", route: "/cities/carmel" }, { name: "Fishers", route: "#" },
          { name: "Noblesville", route: "#" }, { name: "Westfield", route: "#" },
          { name: "Zionsville", route: "#" }, { name: "Avon", route: "#" },
          { name: "Plainfield", route: "#" }, { name: "Brownsburg", route: "#" },
          { name: "Lawrence", route: "#" }, { name: "Beech Grove", route: "#" },
          { name: "Speedway", route: "#" }, { name: "Greenwood", route: "#" },
          { name: "Franklin", route: "#" }, { name: "Greenfield", route: "#" },
          { name: "Anderson", route: "#" }, { name: "Muncie", route: "#" },
        ],
      },
      {
        name: "Hamilton County Suburbs",
        description: "Carmel, Fishers, Noblesville, and Westfield are among the fastest-growing suburbs in the Midwest. All are within 20–30 minutes of the Indianapolis Passport Agency, giving Hamilton County residents the best emergency passport access in Indiana.",
        hub: { name: "Carmel", route: "/cities/carmel" },
        communities: [
          { name: "Fishers", route: "#" }, { name: "Noblesville", route: "#" },
          { name: "Westfield", route: "#" }, { name: "Arcadia", route: "#" },
          { name: "Atlanta", route: "#" }, { name: "Cicero", route: "#" },
          { name: "Sheridan", route: "#" }, { name: "Tipton", route: "#" },
          { name: "Kokomo", route: "#" }, { name: "Elwood", route: "#" },
          { name: "Alexandria", route: "#" }, { name: "Pendleton", route: "#" },
          { name: "Fortville", route: "#" }, { name: "Lapel", route: "#" },
          { name: "McCordsville", route: "#" }, { name: "New Palestine", route: "#" },
        ],
      },
    ],
  },
  {
    id: "northeast-indiana",
    name: "Northeast Indiana",
    icon: "ri-flag-line",
    subregions: [
      {
        name: "Fort Wayne & Allen County",
        description: "Fort Wayne is Indiana's second largest city and the Northeast Indiana hub. The Purdue Fort Wayne campus and the Allen County manufacturing corridor generate significant travel demand. Fort Wayne International (FWA) offers direct flights to Atlanta and Chicago. Chicago and Indianapolis agencies are 2–3 hours away.",
        hub: { name: "Fort Wayne", route: "/cities/fort-wayne" },
        communities: [
          { name: "New Haven", route: "#" }, { name: "Huntington", route: "#" },
          { name: "Columbia City", route: "#" }, { name: "Auburn", route: "#" },
          { name: "Kendallville", route: "#" }, { name: "Angola", route: "#" },
          { name: "Decatur", route: "#" }, { name: "Bluffton", route: "#" },
          { name: "Wabash", route: "#" }, { name: "Marion", route: "#" },
          { name: "Warsaw", route: "#" }, { name: "Plymouth", route: "#" },
          { name: "Logansport", route: "#" }, { name: "Peru", route: "#" },
          { name: "Frankfort", route: "#" }, { name: "Delphi", route: "#" },
        ],
      },
      {
        name: "South Bend & North Indiana",
        description: "South Bend, Mishawaka, Elkhart, and Goshen form the North Indiana corridor. The University of Notre Dame generates significant international travel demand. South Bend International (SBN) offers direct flights. The Indiana Toll Road (I-80/I-90) connects the area to Chicago.",
        hub: { name: "South Bend", route: "#" },
        communities: [
          { name: "Mishawaka", route: "#" }, { name: "Elkhart", route: "#" },
          { name: "Goshen", route: "#" }, { name: "Granger", route: "#" },
          { name: "Osceola", route: "#" }, { name: "Nappanee", route: "#" },
          { name: "Bristol", route: "#" }, { name: "Middlebury", route: "#" },
          { name: "Shipshewana", route: "#" }, { name: "Ligonier", route: "#" },
          { name: "North Webster", route: "#" }, { name: "Syracuse", route: "#" },
          { name: "Warsaw", route: "#" }, { name: "Milford", route: "#" },
          { name: "Winona Lake", route: "#" }, { name: "Pierceton", route: "#" },
        ],
      },
    ],
  },
  {
    id: "southwest-indiana",
    name: "Southwest Indiana",
    icon: "ri-water-flash-line",
    subregions: [
      {
        name: "Evansville & Tri-State Area",
        description: "Evansville is the Southwest Indiana hub and the third largest city in the state. The Ohio River corridor connects Indiana, Kentucky, and Illinois. Evansville Regional (EVV) offers direct flights. The University of Evansville and the healthcare corridor generate significant travel.",
        hub: { name: "Evansville", route: "/cities/evansville" },
        communities: [
          { name: "Newburgh", route: "#" }, { name: "Mount Vernon", route: "#" },
          { name: "Boonville", route: "#" }, { name: "Princeton", route: "#" },
          { name: "Vincennes", route: "#" }, { name: "Washington", route: "#" },
          { name: "Jasper", route: "#" }, { name: "Tell City", route: "#" },
          { name: "Santa Claus", route: "#" }, { name: "Dale", route: "#" },
          { name: "Petersburg", route: "#" }, { name: "Huntingburg", route: "#" },
          { name: "Ferdinand", route: "#" }, { name: "Oakland City", route: "#" },
          { name: "Loogootee", route: "#" }, { name: "Linton", route: "#" },
        ],
      },
      {
        name: "Terre Haute & West Indiana",
        description: "Terre Haute, Indiana State University, and the Wabash River corridor form West Indiana. The US-41 and I-70 connect the area to Indianapolis and Chicago. Terre Haute International (HUF) is the regional airport.",
        hub: { name: "Terre Haute", route: "#" },
        communities: [
          { name: "Clinton", route: "#" }, { name: "Rockville", route: "#" },
          { name: "Sullivan", route: "#" }, { name: "Brazil", route: "#" },
          { name: "Marshall", route: "#" }, { name: "Greencastle", route: "#" },
          { name: "Cloverdale", route: "#" }, { name: "Crawfordsville", route: "#" },
          { name: "Covington", route: "#" }, { name: "Fountain County", route: "#" },
          { name: "Attica", route: "#" }, { name: "Newport", route: "#" },
          { name: "Veedersburg", route: "#" }, { name: "Rensselaer", route: "#" },
          { name: "Remington", route: "#" }, { name: "Francesville", route: "#" },
        ],
      },
    ],
  },
  {
    id: "northwest-indiana",
    name: "Northwest Indiana",
    icon: "ri-building-4-line",
    subregions: [
      {
        name: "Gary & Lake County (Chicago Suburbs)",
        description: "Gary, Hammond, East Chicago, and Merrillville are part of the Chicago metropolitan area. Lake County Indiana residents are only 30–40 minutes from the Chicago Passport Agency. The South Shore Line rail connects the area to downtown Chicago. The Indiana Dunes National Park draws significant summer travel.",
        hub: { name: "Gary", route: "#" },
        communities: [
          { name: "Hammond", route: "#" }, { name: "East Chicago", route: "#" },
          { name: "Merrillville", route: "#" }, { name: "Hobart", route: "#" },
          { name: "Crown Point", route: "#" }, { name: "Munster", route: "#" },
          { name: "Highland", route: "#" }, { name: "Griffith", route: "#" },
          { name: "Whiting", route: "#" }, { name: "Dyer", route: "#" },
          { name: "Schererville", route: "#" }, { name: "St. John", route: "#" },
          { name: "Portage", route: "#" }, { name: "Valparaiso", route: "#" },
          { name: "Chesterton", route: "#" }, { name: "Michigan City", route: "#" },
        ],
      },
      {
        name: "Purdue & North Central",
        description: "Lafayette, West Lafayette, Kokomo, and Logansport are the North Central Indiana communities. Purdue University generates enormous international travel demand. The I-65 connects the corridor to Indianapolis and Chicago.",
        hub: { name: "Lafayette", route: "#" },
        communities: [
          { name: "West Lafayette", route: "#" }, { name: "Kokomo", route: "#" },
          { name: "Logansport", route: "#" }, { name: "Peru", route: "#" },
          { name: "Frankfort", route: "#" }, { name: "Delphi", route: "#" },
          { name: "Monticello", route: "#" }, { name: "Rochester", route: "#" },
          { name: "Winamac", route: "#" }, { name: "Rensselaer", route: "#" },
          { name: "Crawfordsville", route: "#" }, { name: "Attica", route: "#" },
          { name: "Covington", route: "#" }, { name: "Fountain County", route: "#" },
          { name: "Elmore City", route: "#" }, { name: "Colfax", route: "#" },
        ],
      },
    ],
  },
  {
    id: "south-indiana",
    name: "South Central Indiana",
    icon: "ri-tree-line",
    subregions: [
      {
        name: "Bloomington & Monroe County",
        description: "Bloomington and Indiana University form the South Central Indiana academic hub. IU generates massive international travel demand — students, faculty, and researchers. The US-46, IN-37, and I-69 connect Bloomington to Indianapolis. Monroe County Airport (BMG) is the local airport.",
        hub: { name: "Bloomington", route: "#" },
        communities: [
          { name: "Ellettsville", route: "#" }, { name: "Smithville", route: "#" },
          { name: "Spencer", route: "#" }, { name: "Martinsville", route: "#" },
          { name: "Bedford", route: "#" }, { name: "Paoli", route: "#" },
          { name: "French Lick", route: "#" }, { name: "West Baden Springs", route: "#" },
          { name: "Mitchell", route: "#" }, { name: "Orleans", route: "#" },
          { name: "Salem", route: "#" }, { name: "Scottsburg", route: "#" },
          { name: "Madison", route: "#" }, { name: "North Vernon", route: "#" },
          { name: "Seymour", route: "#" }, { name: "Columbus", route: "#" },
        ],
      },
      {
        name: "Columbus & Bartholomew County",
        description: "Columbus, home of Cummins Inc., is a world-renowned architectural city. The corporate headquarters generates significant international business travel. The I-65 and US-31 connect Columbus to Indianapolis (45 minutes north).",
        hub: { name: "Columbus", route: "#" },
        communities: [
          { name: "Edinburgh", route: "#" }, { name: "Hope", route: "#" },
          { name: "Seymour", route: "#" }, { name: "North Vernon", route: "#" },
          { name: "Hartsville", route: "#" }, { name: "Nashville", route: "#" },
          { name: "Brown County", route: "#" }, { name: "Greensburg", route: "#" },
          { name: "Rushville", route: "#" }, { name: "Shelbyville", route: "#" },
          { name: "Franklin", route: "#" }, { name: "Trafalgar", route: "#" },
          { name: "Bargersville", route: "#" }, { name: "Whiteland", route: "#" },
          { name: "Greenwood", route: "#" }, { name: "New Whiteland", route: "#" },
        ],
      },
    ],
  },
];

export default function IndianaCommunitiesWeServe() {
  const [activeRegion, setActiveRegion] = useState(regions[0].id);
  const current = regions.find((r) => r.id === activeRegion) || regions[0];

  return (
    <section id="communities" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Statewide Coverage
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Communities We Serve Across Indiana
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Don&apos;t see your city in the directory above? You&apos;re still covered. Every Indiana community below is served through our nearest hub — with the same fast, reliable expedited passport processing.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {regions.map((region) => (
            <button
              key={region.id}
              onClick={() => setActiveRegion(region.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeRegion === region.id
                  ? "bg-[#1A365D] text-white"
                  : "bg-[#EEF2F8] text-[#1A365D] hover:bg-[#dce5f3]"
              }`}
            >
              <i className={`${region.icon} text-base`}></i>
              {region.name}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {current.subregions.map((sub, i) => (
            <div key={i} className="bg-[#F7F8FA] rounded-lg p-6 border border-gray-100">
              <div className="flex items-start justify-between gap-4 mb-3">
                <h3 className="font-bold text-[#1A365D] text-base">{sub.name}</h3>
                <a
                  href={sub.hub.route}
                  className="inline-flex items-center gap-1 bg-[#1A365D] text-white text-xs font-semibold px-3 py-1.5 rounded-full hover:bg-[#F6C344] hover:text-[#1A365D] transition-all whitespace-nowrap flex-shrink-0"
                >
                  Hub: {sub.hub.name} <i className="ri-arrow-right-line"></i>
                </a>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{sub.description}</p>
              <div className="flex flex-wrap gap-2">
                {sub.communities.map((c, j) => (
                  <a
                    key={j}
                    href={c.route}
                    className="inline-flex items-center text-xs font-medium text-[#1A365D] bg-white border border-gray-200 rounded-full px-3 py-1 hover:border-[#F6C344] transition-all whitespace-nowrap cursor-pointer"
                  >
                    {c.name}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-400 text-sm mt-8">
          Not finding your exact community?{" "}
          <a href="tel:8772530084" className="text-[#1A365D] font-semibold hover:text-[#F6C344] transition-colors">
            Call us at 877-253-0084
          </a>{" "}
          — we serve all of Indiana.
        </p>
      </div>
    </section>
  );
}